import React, { useState } from "react";
import "./style.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import leftArrow from "../../../assests/leftArrow.svg";
import Button from "react-bootstrap/Button";
import LoadingSpinner from "../../Loading/component";
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";
import Grid from '@mui/material/Grid';

const DaalchiniPointsComp = (
  props

) => {

  const navigate = useNavigate();
  const arrowClick = () => {
    navigate("/");
  };


  return (
    <>
      {props.loawding ? (
        <>
          <LoadingSpinner />
        </>
      ) : (
        <div className="main-div">
          <div>
            <Sidebar />
          </div>

          <div style={{ margin: "auto" }}>
          <div style={{ marginLeft: "12px", marginTop: "20px" }}>
          <h2>
            <img
              onClick={arrowClick}
              style={{ width: "22px", cursor: "pointer" }}
              src={leftArrow}
              alt=""
            />{" "}
            Daalchini points
          </h2>
        </div>



            <div className="order-main-sec1">
              <Box sx={{ p: 1, }} width="25vw">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Enter Mobile Number"
                      variant="outlined"
                      value={props.daalchinipointMobile}
                      onChange={props.handleDaalchiniPointMobile}
                      inputProps={{ maxLength: 10 }}
                      autoComplete="off"
                      onKeyPress={props.handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Enter Amount"
                      variant="outlined"
                      value={props.daalchinipointAmount}
                      onChange={props.handleDaalchiniPointAmount}
                      autoComplete="off"
                      onKeyPress={props.handleKeyPress}
                    />
                  </Grid>
                  <Grid item xs={12} >

                    <div className="d-grid gap-1"  >
                      <Button variant="success" style={{ fontSize: "18px",  }} onClick={props.daalchiniAddPointApi}  >
                        Submit
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DaalchiniPointsComp;
